import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateComponent } from './user/activate/activate.component';
import { ProfileComponent } from './user/profile/profile.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { IdentityGuard } from './user/services/identity.guard';
import { AdminGuard } from './user/services/admin.guard';

const routes: Routes = [
  { path: '',   redirectTo: '/admin/m/h', pathMatch: 'full', canActivate: [IdentityGuard, AdminGuard]},
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'm', loadChildren: () => import('./member/member.module').then(m => m.MemberModule) },
  { path: 'u/a', component: ActivateComponent    },
  { path: 'u/p', component: ProfileComponent    },
  { path: '**', component: PageNotFoundComponent, canActivate: [IdentityGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
